module.exports = __webpack_public_path__ + "assets/webgl/Assets_3_base_color.jpg.dxt.6459cd16.ktx";